var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSmallDefault = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.7223 132.001L14.9339 132.001L82.2282 17.6006L131.017 17.6006L63.7223 132.001Z",
    fill: "#329EF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9643 69.7529L3.99945 69.7529L35.1231 17.5998L67.0879 17.5998L35.9643 69.7529Z",
    fill: "#329EF0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.512 132.001L80.5468 132.001L115.035 73.1184L147 73.1184L112.512 132.001Z",
    fill: "#329EF0"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSmallDefault);
export default ForwardRef;